export const formValues = {
    situation: '',
    experienceYears: '',
    sex: '',
    birthday: '',
    prefecture: null,
    city: null,
    postalCode: '',
    cityAddressId: null,
    firstName: '',
    lastName: '',
    firstNameKana: '',
    lastNameKana: '',
    tel: '',
    lineId: '',
    email: '',
    password: '',
    userResumesAttributes: {
        0: {
            companyName: '',
            brandName: '',
            storeName: '',
            resumeAuto: false,
            employmentId: null,
            genreId: null,
            occupationIds: null,
            detailedJobDetails: '',
            workStartYear: '',
            workStartMonth: '',
            workEndDateYear: null,
            workEndDateMonth: null,
            userOccupationResumesAttributes: [{ occupationId: null }],
        },
    },
    mailMagazine: 0,
    agentService: 0,
    lineContactPreferred: 0,
    residentStatus: '',
}

export const displayValues = {
    situation: '',
    prefectureCity: '',
    name: '',
    nameKana: '',
    birthday: '',
    sex: '',
    tel: '',
    lineId: '',
    email: '',
    password: '',
    companyName: '',
    brandName: '',
    storeName: '',
    workStartDate: '',
    workEndDate: null,
    experienceYears: '',
    employment: null,
    genre: null,
    occupation: null,
    detailedJobDetails: '',
    lineContactPreferred: 0,
}
